import { useState } from "react";
import { channels } from "@/mocks/home";

export default function ChannelsSection() {
  const [active, setActive] = useState(channels[0].key);
  const current = channels.find((c) => c.key === active) ?? channels[0];

  return (
    <section id="channels" className="w-full bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-layout-grid-line"></i>
              内容频道
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
              站内主要频道一览
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              樱桃视频把内容按使用场景划分成若干频道。切换下方标签即可查看每个频道的定位、
              常见分类与浏览方式，帮助你快速找到想看的内容方向。
            </p>
          </div>

          <div className="mt-9 flex flex-wrap gap-2">
            {channels.map((ch) => (
              <button
                key={ch.key}
                type="button"
                onClick={() => setActive(ch.key)}
                className={`inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium border transition-colors cursor-pointer whitespace-nowrap ${
                  active === ch.key
                    ? "bg-primary-500 border-primary-500 text-background-50"
                    : "bg-background-50 border-background-200/70 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
                }`}
              >
                <i className={ch.icon}></i>
                {ch.label}
              </button>
            ))}
          </div>

          <div className="mt-6 rounded-lg bg-background-50 border border-background-200/70 overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-5">
              <div className="lg:col-span-3 p-6 md:p-8">
                <div className="flex items-center gap-3">
                  <span className="w-12 h-12 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                    <i className={`${current.icon} text-2xl`}></i>
                  </span>
                  <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950">
                    {current.title}
                  </h3>
                </div>
                <p className="mt-5 text-sm md:text-base text-foreground-700 leading-relaxed">{current.desc}</p>
                <div className="mt-6">
                  <h4 className="text-xs font-medium text-foreground-500 tracking-wide">常见分类</h4>
                  <div className="mt-3 flex flex-wrap gap-2">
                    {current.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
                <p className="mt-6 inline-flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-list-check-2"></i>
                  {current.meta}
                </p>
              </div>

              <div className="lg:col-span-2 bg-secondary-50 p-6 md:p-8 border-t lg:border-t-0 lg:border-l border-background-200/70">
                <h4 className="font-heading text-sm font-semibold text-foreground-950">浏览小贴士</h4>
                <ul className="mt-4 space-y-3">
                  <li className="flex gap-2 items-start">
                    <i className="ri-checkbox-circle-line text-primary-600 mt-0.5"></i>
                    <span className="text-sm text-foreground-700 leading-relaxed">频道内内容按更新与热度排序，方便跟进。</span>
                  </li>
                  <li className="flex gap-2 items-start">
                    <i className="ri-checkbox-circle-line text-primary-600 mt-0.5"></i>
                    <span className="text-sm text-foreground-700 leading-relaxed">收藏喜爱的分类入口，下次浏览更省时间。</span>
                  </li>
                  <li className="flex gap-2 items-start">
                    <i className="ri-checkbox-circle-line text-primary-600 mt-0.5"></i>
                    <span className="text-sm text-foreground-700 leading-relaxed">不同频道支持连续播放，适合长时间观看。</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}